import {operatorInfo} from "../functions/greetingsPage/OperatorInfo";
import {useNavigate, useLocation, useParams} from "react-router-dom";
import {sendLog} from "../functions/common/SendLog";
import React, {useEffect, useState} from "react";
import CheckBox from "../Components/CheckBox";
import packageJson from '../../package.json';
import {CONFIG, ServerApi} from "../api/ServerApi";

//Стили
import "./style/greeting.css";
import "./style/palette.css";
import "./style/common.css";

//Страница №1
//Страница приложения с ознакомлением и подтверждением политики конфиденциальности
export default function GreetingsPage() {
    const [visibleStatus, setVisibleStatus] = useState("d-block");
    const [errorMessage, setErrorMessage] = useState(null);
    const [isDisabled, setIsDisabled] = useState(true);
    const [isChecked, setIsChecked] = useState(false);
    const [currIp, setCurrIp] = useState('');
    const [ip, setIp] = useState('');

    // Добавлено состояние для типа логики (для тернарного оператора ниже)
    const [appType, setAppType] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();

    //? Пробуем, тест
    // const { prefix, id } = useParams();
    // console.log(prefix);
    // console.log(id);

    const title = 'Страница 1. Ознакомление и подтверждение политики конфиденциальности.';
    let modelPhone = navigator.userAgent;
    const serverApi = new ServerApi();
    const rawError = location.state?.error;
    // navError после этой нормализации ВСЕГДА либо массив строк, либо null
    const navError = Array.isArray(rawError) ? rawError : (typeof rawError === 'string' ? [rawError] : null);

    //Check box, галочка активна или нет "Я согласен с политикой конфиденциальности"
    const handleCheckboxChange = () => {
        setIsChecked((prevState) => !prevState);
        setIsDisabled(!isDisabled);
    };

    //Клик кнопки продолжить "Продолжить"
    const handleButtonClick = () => {
        if (!isDisabled) {
            navigate("/view");
        }
    };

    useEffect(() => {
        setVisibleStatus("d-none");

        // Если пришла ошибка навигации — запрос Init и operatorInfo не делаем
        if (navError) {
            setVisibleStatus("d-block");
            return;
        }

        //! Боевой
        //let currentURL = window.location.href;

        //? Пробуем, тест
        // const currentURL = (prefix && id) ? `${window.location.origin}/${prefix}/${id}` : window.location.href;
        // console.log(prefix);
        // console.log(id);
        // console.log(currentURL);
        //const currentURL = window.location.origin + window.location.pathname;

        const currentURL = window.location.href;

        // console.log('currentURL = ' + currentURL);
        // console.log("==================== ПРОВЕРКА ====================");
        // console.log("window.location.href =", window.location.href);
        // console.log("window.location.origin =", window.location.origin);
        // console.log("window.location.pathname =", window.location.pathname);
        // console.log("==================== КОНЕЦ ====================");

        //Расшифровка ссылки, возвращает код пользователя и оператора.
        serverApi.Init(currentURL).then((response) => {
            //console.log(response);

            sendLog(serverApi, title, 'Разбор ссылки.', 'Init', false, {modelPhone, response});
            if (response.status === 200) {
                if (response.data.success) {
                    const res = response.data.data;

                    if (res.code && res.type) {
                        localStorage.setItem('doc_session_code', res.code);
                        localStorage.setItem('app_logic_type', res.type);
                        localStorage.setItem('app_debag', res.debag);

                        // Сохраняем тип в состояние для условного рендеринга текста
                        setAppType(res.type);

                        //Возвращает данные об операторе. Название компании.
                        operatorInfo(serverApi, title, res.code, res.debag, res.type);
                    }
                    setVisibleStatus("d-block");
                } else {
                    const errorData = response?.data?.error;
                    if (errorData) {
                        setErrorMessage(errorData);
                    } else if (errorData !== '') {
                        setErrorMessage(errorData);
                    } else {
                        setErrorMessage('Пользователь не найден');
                    }
                }
            } else {
                setErrorMessage('Пользователь не найден');
            }
        }).catch((error) => {
            setErrorMessage('Пользователь не найден');
            sendLog(serverApi, title, 'Разбор ссылки.', 'Init', true, {modelPhone, error});
        });

        //! Боевой
    }, []);

    //? Пробуем, тест
    //}, [prefix, id]);

    //
    useEffect(() => {
        //! Пока прибито жестко
        setIp('');
        setCurrIp('RU');
    }, []);

    return (
        <div className={"d-flex flex-column align-items-center"}>

            {CONFIG.SERVER_URL === 'https://serv.idgos.ru/index.php' &&
                <div className={'w-100 text-start ms-3'}>
                    Тест - 11.08.2026
                </div>
            }

            <div id={"greeting"}>
                <div id={"greeting-block"} className={"mx-2"}>
                    <div className={"greeting-img-block"}>
                        {/*<img src={"../icons/logo-idgos.png"} alt={"!#"} className={"logo-idgos"}/>*/}
                        <img src={"/icons/logo-idgos.png"} alt={"Логотип"} className={"logo-idgos"}/>
                    </div>
                    <div className={"greeting-text-block"}>
                        <h1 className={"greeting-title text-center"}>
                            Добро пожаловать IDGOS
                        </h1>
                        <p className={"greeting-subtitle text-center"}>
                            {Number(appType) === 2 ?
                                "Страница для актуализации своих персональных данных через портал ЕСИА" :
                                "Сервис для подписания документов через ГосУслуги"
                            }
                        </p>
                        {navError && navError.map((item, index) => (
                            <p key={index} className="greeting-subtitle text-center fw-bold color_red d-block">
                                {item}
                            </p>
                        ))}

                        {!navError &&
                            <p className={`greeting-subtitle text-center fw-bold color_red ${errorMessage ? 'd-block' : 'd-none'}`}>
                                {errorMessage || 'Ваша ссылка просрочена'}
                            </p>
                        }
                    </div>

                    {/* Если есть navError — не показываем ни форму согласия, ни блок IP-ошибки */}
                    {!navError && (
                        <>
                            {currIp == 'RU' || currIp == 'UA' ?
                                <>
                                    <div className={`${visibleStatus} mb-3`}>
                                        <CheckBox label={"Я согласен с политикой конфиденциальности"} checked={isChecked}
                                                  onChange={handleCheckboxChange}/>
                                    </div>
                                    <div className={`greeting-btn-block ${visibleStatus}`}>
                                        <button onClick={handleButtonClick} disabled={isDisabled}
                                                className={`border-0 greeting-continue ${isDisabled ? 'greeting-continue-true' : 'greeting-continue-false'}`}>
                                            Продолжить
                                        </button>
                                    </div>
                                    {/*</> : (currIp == '' ? <img className={'width30px'} src="../icons/VAyR.gif"/> :*/}
                                </> : (currIp == '' ? <img className={'width30px'} src="/icons/VAyR.gif"/> :
                                        (currIp == 'Поризошла ошибка' ?
                                                <p className={'text-center'}>
                                                    Произошла ошибка , попробуйте перезагрузить страницу
                                                </p> :
                                                <>
                                                    <p className={'text-center fw-bold'}>Внимание!</p>
                                                    <p className={'text-center'}>Нет возможности доступа.</p>
                                                    <p className={'text-center'}>Ваш IP адрес принадлежит другой стране.</p>
                                                    <p className={'text-center'}>Отключите VPN или вернитесь в матушку
                                                        Россию)</p>
                                                    <p className={'text-center'}>IP адрес: {currIp}{' '}{ip}</p>
                                                </>
                                        )
                                )
                            }
                        </>
                    )}
                </div>
            </div>
            <div className={"app-version text-end width90"}>версия {packageJson.version}</div>
        </div>
    );
};
